import { Box, Chip } from "@mui/joy";

function NewsTags({ tags }) {
  return (
    <Box sx={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 0.5,
      mb: 1,
      overflow: "hidden",
    }}>
      {tags.slice(0, 3).map((tag) => (
        <Chip
          key={tag}
          size="sm"
          variant="outlined"
          color="neutral"
        >
          {tag}
        </Chip>
      ))}
    </Box>
  );
}

export default NewsTags;